import type { DraggableAttributes, DraggableSyntheticListeners } from '@dnd-kit/core';
import { htmlToText } from 'core/utils/htmlToText';
import type React from 'react';

type Translate = (key: string, options?: Record<string, string>) => string;
type InertAttribute = { inert?: '' };

type DragHandleParams = {
  attributes: DraggableAttributes;
  isDragOverlay: boolean;
  listeners: DraggableSyntheticListeners;
  reorderMode: boolean;
};

type DragHandleBindings = {
  dragHandleProps: Partial<DraggableAttributes>;
  isDragHandleInteractive: boolean;
  rowDragListeners: DraggableSyntheticListeners;
};

// Cadena vacía porque React 17 no reconoce `inert`; en React 19 es booleano y '' cuenta como false (migración: TAN-10848).
export function getInertProps(isInert: boolean): React.HTMLAttributes<HTMLDivElement> {
  const inertProps: React.HTMLAttributes<HTMLDivElement> & InertAttribute = { inert: '' };
  return isInert ? inertProps : {};
}

/** «Etiqueta, nombre del elemento» para distinguir botones repetidos por fila; sin nombre, solo la etiqueta. */
export function getLabelWithContext(t: Translate, label: string, name?: string | null): string {
  const context = htmlToText(name);
  return context ? t('new-course:Label with context', { label, context }) : label;
}

/** Atributos al asa y listeners a la fila: el teclado arranca solo desde el asa y el ratón desde toda la fila. */
export function getDragHandleBindings({ attributes, isDragOverlay, listeners, reorderMode }: DragHandleParams): DragHandleBindings {
  const isDragHandleInteractive = reorderMode && !isDragOverlay;
  if (!isDragHandleInteractive) {
    return { dragHandleProps: {}, isDragHandleInteractive, rowDragListeners: {} };
  }
  return { dragHandleProps: attributes, isDragHandleInteractive, rowDragListeners: listeners };
}
